import React from 'react'
import { Button } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


const ButtonComponent = ({
	variant='primary',
	disabled=false,
	icon=null,
	id,
	size='md',
	title,
	type='submit',
	onClick=null,
	href=null,
	ref=null
}) => {

	const navigate = useNavigate();

	return (
		<>

			<Button
				variant={variant}
				disabled={disabled}
				id={id}
				size={size}
				type={type}
				onClick={onClick}
				href={href && navigate(href)}
				ref={ref}
			>
				{icon && <FontAwesomeIcon icon={icon} style={{ marginRight: '8px' }} />} {title}
			</Button>

		</>
	)

}

export default ButtonComponent;
